import dayjs from 'dayjs'
import { getIn, useFormikContext } from 'formik'
import ReactDatePicker from 'react-datepicker'
import { useIsCliente } from '../../utils/utils'

type FormUtenteValues = {
  expiration_date?: Date | string | null
}

export default function FormChangeExpiration() {
  const { values, setFieldValue, errors, touched } = useFormikContext<FormUtenteValues>()
  const isCliente = useIsCliente()

  return (
    <div className="row">
      <div className="col-6">
        <div className="form-group mb-3">
          <label className="label-m label-field">SCADENZA</label>
          <div className="text-danger error-field">
            {getIn(errors, 'expiration_date') && getIn(touched, 'expiration_date') && getIn(errors, 'expiration_date')}
          </div>
          <ReactDatePicker
            isClearable
            placeholderText="Seleziona data di scadenza"
            className="form-control me-2 text-secondary"
            dateFormat={'dd/MM/yyyy'}
            onChange={(date) => {
              if (date) {
                setFieldValue('expiration_date', dayjs(date).format('YYYY-MM-DD'))
              } else {
                setFieldValue('expiration_date', null)
              }
            }}
            selected={values.expiration_date ? dayjs(values.expiration_date).toDate() : null}
            disabled={isCliente}
            filterDate={(date) => dayjs().isBefore(date, 'day') || dayjs().isSame(date, 'day')}
          />
        </div>
      </div>
    </div>
  )
}
